import _ from '@lodash';
import TransformerService from './TransformerService';

class StorageTransformerService {
	constructor() {
		this.inputAttributeResult = [];
		this.outputKeysResult = [];
	}

	getInputAttributesListSelection(id) {
		if (_.isUndefined(this.inputAttributeResult[id]))
			return new Promise((resolve, reject) => {
				TransformerService.getInputAttributesListSelection(id)
					.then(resp => {
						this.inputAttributeResult[id] = resp;
						resolve(resp);
					})
					.catch(e => reject(e));
			});
		return new Promise(resolve => {
			resolve(this.inputAttributeResult[id]);
		});
	}

	getOutputKeysSelection(id) {
		if (_.isUndefined(this.outputKeysResult[id]))
			return new Promise((resolve, reject) => {
				TransformerService.getOutputKeysSelection(id)
					.then(resp => {
						this.outputKeysResult[id] = resp;
						resolve(resp);
					})
					.catch(e => reject(e));
			});
		return new Promise(resolve => {
			resolve(this.outputKeysResult[id]);
		});
	}
}
export default StorageTransformerService;
